import React, { useContext } from 'react'
import { Content, Layout, Navigation, Responsive } from 'ui'

export interface DataManagementShellProps {
  returnUrl?: string
  linkText?: string
  heading?: string
  subHeading?: string
  main?: React.ReactNode | React.ReactNode[]
  aside?: React.ReactNode | React.ReactNode[]
}

const GRID_STYLES: string = 'grid grid-cols-1 xl:grid-cols-4'
const GRID_ITEM_STYLES: string = 'col-span-3 md:pr-3'
const ASIDE_STYLES: string =
  'aside flex flex-row flex flex-wrap md:flex-col flex md:flex-no-wrap'

export const DataManagementShell: React.FC<DataManagementShellProps> = ({
  returnUrl,
  linkText,
  heading,
  subHeading,
  main,
  aside,
}) => {
  const { useDisplayMode } = useContext(Responsive.DrawerManagerContext)
  useDisplayMode('expanded')

  return (
    <Layout.PaddedContent>
      {returnUrl && linkText ? (
        <Navigation.ReturnLink to={returnUrl}>{linkText}</Navigation.ReturnLink>
      ) : null}
      <Content.Heading>{heading}</Content.Heading>
      <Content.SubHeading>{subHeading}</Content.SubHeading>
      <div className={GRID_STYLES}>
        <div className={GRID_ITEM_STYLES}>{main}</div>
        <aside className={ASIDE_STYLES}>{aside}</aside>
      </div>
    </Layout.PaddedContent>
  )
}
